export default "__VITE_ASSET__JrqYnDsK__"